import React from "react";

const projects = [
    {
        name: "Generative Excel Data Assistant",
        languages: ["RAG", "Python", "OpenAI"],
        link: "https://github.com/thomasruegg/generative-excel-data-assistant",
        img: "GEDA.png"
    },
    {
        name: "Object Detection for K900 Robot",
        languages: ["YOLOv11", "FastSAM", "FusionVision", "Python"],
        link: "https://www.linkedin.com/posts/patrick-wissiak_enhancing-industrial-cleaning-robots-with-ugcPost-7284608249419431937-tOoU",
        img: "kemaro-k900.png"
    },
    {
        name: "Gallery",
        languages: ["Next.js", "React", "Drizzle", "Clerk"],
        link: "https://github.com/thomasruegg/gallery",
        img: "nextjs-gallery.jpg"
    },
    {
        name: "Train Delay Visualizer",
        languages: ["Prisma", "React", "TypeScript"],
        link: "https://github.com/TrainDelayVisualizer/TrainDelayVisualizer",
        img: "train-delay-visualizer.png"
    },
    {
        name: "Journaling App",
        languages: ["Android SDK", "Kotlin", "MVVM", "RoomDB"],
        link: "https://github.com/thomasruegg/dayournal",
        img: "journal.jpg"
    },
    {
        name: "Convolutional Neural Networks",
        languages: ["Python", "TensorFlow", "Kaggle", "Conda"],
        link: "https://github.com/thomasruegg/cnn-image-classification",
        img: "convolutional-neural-networks.jpeg"
    },
    {
        name: "Skylar Chatbot",
        languages: ["NLP", "Python", "Google Dialogflow"],
        link: "https://github.com/thomasruegg/skylar",
        img: "google-cloud.jpg"
    },
    {
        name: "Stable Diffusion Bot",
        languages: ["Python", "VueJS", "Stable Diffusion"],
        link: "https://github.com/thomasruegg/stable-diffusion-avatar-generator",
        img: "dogger.jpg"
    },
    {
        name: "Parallelized Matrix Multiplication",
        languages: ["NVIDIA Cuda", "C++"],
        link: "https://github.com/thomasruegg/cuda-parallel-matrix-multiplication",
        img: "matrix-multiplication-1.png"
    },
    {
        name: "Clean Code Summary",
        languages: ["Book by Robert C. Martin"],
        link: "https://github.com/thomasruegg/clean-code-summary",
        img: "clean-code-book.png"
    },
    {
        name: "macOS Essentials",
        languages: ["Brew", "Zsh"],
        link: "https://github.com/thomasruegg/macos-essentials",
        img: "mac-essentials.jpg"
    },
    {
        name: "Android Repackaging Attack",
        languages: ["SMALI", "Ubuntu", "Android SDK"],
        link: "https://github.com/thomasruegg/android-repackaging-attack",
        img: "android-wallpaper.jpg"
    },
    // {
    //     name: "Extended Rock Paper Scissors Game",
    //     languages: ["HTML", "CSS", "JavaScript"],
    //     link: "not-ready-yet",
    //     img: "rock-paper-scissors.png"
    // },
    // {
    //     name: "Bank of Rapperswil",
    //     languages: ["React", "Angular", "TypeScript"],
    //     link: "github.com",
    //     img: "mac-essentials.jpg"
    // },
]


function Projects() {
    return (
        <section id={"projects"} className={"projects-container"}>
            <div className={"projects-headline"}>Projects</div>
            <div className={"projects-wrapper"}>
                {projects.map(project => (
                    <a className={"projects-card"} href={project.link} target={"_blank"} rel="noreferrer" key={project.name}
                        style={{ backgroundPosition: "center", backgroundSize: "100%", backgroundClip: "fill", backgroundImage: `url(${require(`../images/creations-section/${project.img}`)})` }}>
                        <div className={"projects-card-gradient"}></div>
                        <div className={"projects-card-links"}></div>
                        <h3 className={"projects-card-name"}>{project.name}</h3>
                        <div className={"projects-card-languages"}>
                            {project.languages.map(language => (
                                <span key={language + project.name}>{language}</span>
                            ))}
                        </div>
                    </a>
                ))}
            </div>
        </section>
    )
}

export default Projects;